import axios from 'axios';

import store from '../../redux/store';
import { userOperations } from '../../redux/user';

/**
 * This is the base for writing to our MongoDB database.
 * /misc is the endpoint which allows you to write to our misc collection
 * /misc/search allows you to pull up a record
 * Both are currently get requests but this may change in the future.
 */
const config = {
    baseURL: __NGX_BASE__,
    headers: {
        Authorization: 'X-API-Key ak2vyk28sn50sai4dzaewkz46w6ovdf0',
        'Content-Type': 'application/json',
    },
};

let axios1 = axios.create(config);

axios1.interceptors.response.use(null, function (error) {
    if (error && (!error.response || error.response.status === 401)) {
        console.log('error contacting ' + config.baseURL);
        // sessionStorage.clear();
        // localStorage.clear();
        // store.dispatch(userOperations.userLogoutOp());
    }
    return Promise.reject(error);
});

/****
 * Searches for all objects in DB by type
 */
export const searchByType = async (company) => {
    return await axios1.post('/misc/search', { type: company });
};

export const miscSearch = async (object) => {
    return await axios1.post('/misc/search', object);
};

export const getVendors = async () => {
    return await axios1
        .post('/misc/search', { object: 'vendor' })
        .then((response) => response);
};

export const postNewObject = async (object) => {
    return await axios1.post('/misc', { object });
};

export default axios1;



// WEBPACK FOOTER //
// ./src/utils/api/ngx_api.js